module.exports = __webpack_public_path__ + "img/chr_ts_1.9875140d.png";